/** Converts the date of a project from the pipeline (YYYY-MM-DD HH:MM) to long format (MONTH DD, YYYY) */
export function formatProjectDate(dateStr) {
  const dateParts = dateStr.replace(/\s\d{2}:\d{2}/g, "").split("-");
  const dateProp = new Date(
    parseInt(dateParts[0]),
    parseInt(dateParts[1]) - 1,
    parseInt(dateParts[2]),
  );

  return dateProp.toLocaleDateString("default", { month: "long", day: "2-digit", year: "numeric" });
}
